import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import { useSearch } from '~libs/searchParams';

import { Button, ClickableIcon, Toolbar } from '~components';
import { SearchBar } from '~components/form-fields/search';
import Icon, { faMagnifyingGlass, faPlus } from '~components/icon';
import { TableView } from '~components/table-view-v3';

import { columns } from '~support-at-home/forms/co-contributions/list';
import { searchFields } from '~support-at-home/forms/co-contributions/search';

import { setTitle } from '~main/actions/login';
import { getAll as getFundingTypes } from '~support-at-home/actions/fundingTypes';
import { useGetClientContributionsQuery } from '~support-at-home/actions/reconciliations';

import CoContributionsWizard from './co-contributions-wizard';

const CoContributions: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  const dispatch = useAppDispatch();
  const [searchBarOpen, setSearchBarOpen] = useState<boolean>(false);
  const [searchParams, setParams] = useSearch('co-contributions-search', {});
  const search = (values: Record<string, any>) => setParams(values);

  const [wizardOpen, setWizardOpen] = useState<boolean>(false);

  useEffect(() => {
    dispatch(getFundingTypes());
    if (isActive) {
      setTitle('Client Co-Contributions');
    }
  }, [isActive]);

  const { data: coContributions = [], isFetching } = useGetClientContributionsQuery(searchParams);

  return (
    <div className="p-2 co-contributions">
      <Toolbar
        id="co-contributions"
        rightCluster={
          <>
            <ClickableIcon
              className="me-2"
              icon={faMagnifyingGlass}
              id="co-contributions-search-button"
              onClick={() => setSearchBarOpen(!searchBarOpen)}
              toolTip="Toggle Search Bar"
            />
            <Button dataCy="co-contributions-new-button" size="sm" color="success" onClick={() => setWizardOpen(true)}>
              <Icon className="me-2" icon={faPlus} />
              New Invoice Batch
            </Button>
          </>
        }
      />
      <SearchBar isOpen={searchBarOpen} fields={searchFields} initialValues={searchParams} onSubmit={search} />
      <TableView
        id="co-contributions-table"
        columns={columns}
        data={coContributions}
        isLoading={isFetching}
        emptyMessage="No co-contributions found"
        readonly
        striped
      />
      <CoContributionsWizard isOpen={wizardOpen} setIsOpen={setWizardOpen} />
    </div>
  );
};

export default CoContributions;
